import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { getTheme } from 'utils/theme-util';
import SignIn from 'components/sign-in/SignIn';
import MemberNavigatorContainer from './member/MemberNavigator.container';
import { ToastContainer } from 'react-toastify';

const AppRouter = ({ queryClient }) => {
  const theme = useSelector((state) => state.commonStates.theme);

  return (
    <ThemeProvider theme={getTheme(theme)}>
      <ToastContainer
        position="top-right"
        autoClose={5000}
        style={{ zIndex: 101010 }}
        hideProgressBar
        newestOnTop={false}
        closeOnClick={false}
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <Switch>
        <Route exact path="/" component={() => <SignIn queryClient={queryClient} />} />
        <Route path="/" component={() => <MemberNavigatorContainer />} />
      </Switch>
    </ThemeProvider>
  );
};

export default AppRouter;
